<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-ios-printer"></i>
        <div class="mg-l-20">
          <h4>{{loginType == '1' ? $t('express.商品标签管理'):$t('express.标签管理')}}</h4>
        </div>
      </div>
      <div class="tx-right">
      	<a v-if="!$root.$children[0].userInfo.rootUrl" class="mg-r-15 tx-info" href="https://help.5yoho.cn/?p=74" target="_blank">{{$t("express.如何设计")}}{{loginType == '1' ? $t('express.商品标签？') : $t('express.标签？')}}</a>
      	<a v-if="isSysRights('PrintLabel.savePrintTpl')" href="javascript:;" class="btn btn-success" @click="openCreateLabel">{{$t("express.新增标签")}}</a>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30">
      <div class="clear-key">
        <a v-show="fName" href="javascript:;" class=" mg-r-15" @click="clearKey('name')">
          {{$t("express.标签名：")}}
          <span class="mg-r-10">{{fName}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a v-show="fType" href="javascript:;" class=" mg-r-15" @click="clearKey('type')">
          {{$t("express.类型：")}}
          <span class="mg-r-10">{{$t(typeArr[fType])}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a v-show="fSpecType" href="javascript:;" class=" mg-r-15" @click="clearKey('specType')">
          {{$t("express.规格：")}}
          <span class="mg-r-10">{{fSpecType == 99 ? $t(specTypeArr[fSpecType]) : specTypeArr[fSpecType]}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a v-show="fStatus" href="javascript:;" class=" mg-r-15" @click="clearKey('status')">
          {{$t("express.状态：")}}
          <span class="mg-r-10">{{$t(statusArr[fStatus])}}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["fName", "fStatus", "fSpecType", "fType"],
  data() {
    return {
      loginType: localStorage.getItem("loginType"),
      statusArr: arrDict.labelStatus,
      specTypeArr: arrDict.labelSpecType,
      typeArr: arrDict.labelType
    };
  },
  methods: {
    clearKey(type) {
      this.$emit("clearKey", type);
    },
    openCreateLabel() {
      this.$emit("openCreateLabel");
    }
  }
};
</script>
